"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es7.symbol.async-iterator");
require("core-js/modules/es6.symbol");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.to-string");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.match");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
var _memberDay = require("@/api/activity/memberDay");
var _secKill = require("@/api/activity/secKill");
var _groupBuy = require("@/api/activity/groupBuy");
var _bonusSend = require("@/api/activity/bonusSend");
var _lottery = require("@/api/activity/lottery");
var _popupConfig = require("@/api/popup/popupConfig");
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 内置图片上传组件（仿 SecKillConfig.vue 模式）
var ImageUpload = {
  name: 'ImageUpload',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      fileList: []
    };
  },
  watch: {
    value: function value(val) {
      this.initFileList(val);
    }
  },
  created: function created() {
    this.initFileList(this.value);
  },
  methods: {
    initFileList: function initFileList(val) {
      if (val) {
        this.fileList = [{
          name: 'image',
          url: this.getDisplayUrl(val)
        }];
      } else {
        this.fileList = [];
      }
    },
    extractPathPrefix: function extractPathPrefix() {
      var prefix = process.env.VUE_APP_IMAGE_PATH || '';
      if (prefix.startsWith('http://') || prefix.startsWith('https://')) {
        try {
          return new URL(prefix).pathname;
        } catch (e) {
          return prefix;
        }
      }
      return prefix;
    },
    getDisplayUrl: function getDisplayUrl(path) {
      if (!path) return '';
      if (path.startsWith('http://') || path.startsWith('https://')) return path;
      var prefix = process.env.VUE_APP_IMAGE_PATH || '';
      var p = prefix.endsWith('/') ? prefix.slice(0, -1) : prefix;
      var v = path.startsWith('/') ? path : '/' + path;
      return p + v;
    },
    beforeUpload: function beforeUpload(file) {
      var isImage = /^image\/(jpeg|jpg|png|gif|bmp|webp)$/.test(file.type);
      if (!isImage) {
        this.$message.error('只支持上传 jpg、jpeg、png、gif、bmp、webp 格式的图片');
        return false;
      }
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB');
        return false;
      }
      return true;
    },
    uploadImage: function () {
      var _uploadImage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
        var loading, res, url, m, pathPrefix, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading = this.$loading({
                lock: true,
                text: '图片上传中...',
                background: 'rgba(255, 255, 255, 0.7)'
              });
              _context.prev = 1;
              _context.next = 2;
              return (0, _memberDay.uploadMemberDayImage)(file);
            case 2:
              res = _context.sent;
              url = res && res.data || res;
              if (url && typeof url === 'string') {
                // 转为相对路径存储
                if (url.startsWith('http://') || url.startsWith('https://')) {
                  try {
                    url = new URL(url).pathname;
                  } catch (e) {
                    m = url.match(/https?:\/\/[^/]+(.+)/);
                    if (m) url = m[1];
                  }
                }
                pathPrefix = this.extractPathPrefix();
                if (pathPrefix && url.startsWith(pathPrefix)) {
                  url = url.substring(pathPrefix.length);
                }
                url = url.replace(/^\/+/, '');
                this.fileList = [{
                  name: 'image',
                  url: this.getDisplayUrl(url)
                }];
                this.$emit('input', url);
                this.$message.success('图片上传成功');
              } else {
                this.$message.error('图片上传失败');
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              this.fileList = [];
              this.$message.error('图片上传失败：' + (_t.message || _t));
            case 4:
              _context.prev = 4;
              loading.close();
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function uploadImage(_x) {
        return _uploadImage.apply(this, arguments);
      }
      return uploadImage;
    }(),
    handleRemove: function handleRemove() {
      this.fileList = [];
      this.$emit('input', '');
    },
    handlePreview: function handlePreview() {
      if (this.fileList.length > 0) {
        window.open(this.fileList[0].url);
      }
    }
  },
  render: function render(h) {
    var _this = this;
    if (this.fileList.length > 0) {
      return h('div', {
        style: {
          position: 'relative',
          width: '100px',
          height: '100px'
        }
      }, [h('img', {
        attrs: {
          src: this.fileList[0].url
        },
        style: {
          width: '100px',
          height: '100px',
          objectFit: 'cover',
          border: '1px solid #dcdfe6',
          borderRadius: '4px',
          cursor: 'pointer',
          display: 'block'
        },
        on: {
          click: this.handlePreview
        }
      }), h('div', {
        style: {
          position: 'absolute',
          top: '-7px',
          right: '-7px',
          width: '16px',
          height: '16px',
          borderRadius: '50%',
          background: '#f56c6c',
          color: '#fff',
          fontSize: '12px',
          lineHeight: '16px',
          textAlign: 'center',
          cursor: 'pointer'
        },
        on: {
          click: this.handleRemove
        }
      }, '×')]);
    }
    return h('el-upload', {
      props: {
        'show-file-list': false,
        'before-upload': this.beforeUpload,
        'http-request': function httpRequest(options) {
          return _this.uploadImage(options.file);
        },
        accept: 'image/*'
      }
    }, [h('div', {
      style: {
        width: '100px',
        height: '100px',
        border: '1px dashed #dcdfe6',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        color: '#909399',
        fontSize: '24px'
      }
    }, '+')]);
  }
};

// 模块类型常量
var MODULE_TYPE = {
  SEC_KILL: 1,
  GROUP_BUY: 2,
  POINTS: 3,
  COUPON: 4,
  LOTTERY: 5,
  POINT_DOUBLE: 6
};
var _default = exports.default = {
  name: 'MemberDayConfig',
  components: {
    ImageUpload: ImageUpload,
    draggable: _vuedraggable.default
  },
  props: {
    id: {
      type: [Number, String],
      default: null
    }
  },
  data: function data() {
    return {
      activeModule: 'setting',
      saving: false,
      loading: false,
      // 主表表单
      form: this.getDefaultForm(),
      timeRange: null,
      preheatRange: null,
      weeksArr: [3, 4, 5, 6, 7],
      // 五个模块（本地状态）
      modules: this.getDefaultModules(),
      // 专区显示顺序（moduleType 数组，可在活动设置中排序）
      zoneOrder: this.getDefaultZoneOrder(),
      weekOptions: [{
        value: 1,
        label: '周一'
      }, {
        value: 2,
        label: '周二'
      }, {
        value: 3,
        label: '周三'
      }, {
        value: 4,
        label: '周四'
      }, {
        value: 5,
        label: '周五'
      }, {
        value: 6,
        label: '周六'
      }, {
        value: 7,
        label: '周日'
      }],
      moduleDefs: [{
        type: MODULE_TYPE.COUPON,
        label: '领券专区',
        itemLabel: '优惠券发放'
      }, {
        type: MODULE_TYPE.SEC_KILL,
        label: '秒杀专区',
        itemLabel: '秒杀活动'
      }, {
        type: MODULE_TYPE.GROUP_BUY,
        label: '拼团专区',
        itemLabel: '拼团活动'
      }, {
        type: MODULE_TYPE.LOTTERY,
        label: '抽奖专区',
        itemLabel: '抽奖活动'
      }, {
        type: MODULE_TYPE.POINTS,
        label: '积分兑换',
        itemLabel: '兑换活动'
      }, {
        type: MODULE_TYPE.POINT_DOUBLE,
        label: '积分翻倍',
        itemLabel: ''
      }],
      // 下拉数据源
      secKillOptions: [],
      groupBuyOptions: [],
      pointsOptions: [],
      // 领券专区-会员日发券选项（xy_bonus_send 仅有效记录，编辑时按ID补录已绑定记录）
      bonusSendOptions: [],
      lotteryOptions: [],
      // 积分翻倍/抽奖专区跳转配置
      pdJumpType: 'community',
      lotteryJumpType: 'community',
      allPage: [],
      mainRules: {
        title: [{
          required: true,
          message: '请输入大标题',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    isWeekIndeterminate: function isWeekIndeterminate() {
      return this.weeksArr.length > 0 && this.weeksArr.length < 7;
    },
    // 按活动设置中的专区顺序返回模块定义（tab 顺序随之变化）
    orderedModuleDefs: function orderedModuleDefs() {
      var _this2 = this;
      return this.zoneOrder.map(function (t) {
        return _this2.moduleDefs.find(function (d) {
          return d.type === t;
        });
      }).filter(Boolean);
    },
    // 左侧仅展示已开启专区的页签，关闭后隐藏、开启后重新展示
    visibleModuleDefs: function visibleModuleDefs() {
      var _this3 = this;
      return this.orderedModuleDefs.filter(function (d) {
        return Number(_this3.getModule(d.type).showStatus) === 1;
      });
    },
    // 跳转页面选项：社区=GAGAS，点餐=GAGAX/DELI
    pdPageOptions: function pdPageOptions() {
      return this.filterPagesByJumpType(this.pdJumpType);
    },
    lotteryPageOptions: function lotteryPageOptions() {
      return this.filterPagesByJumpType(this.lotteryJumpType);
    }
  },
  created: function created() {
    this.fetchPointsRules();
    this.fetchSecKills();
    this.fetchGroupBuys();
    this.fetchLotteries();
    this.fetchPageList();
    this.fetchBonusSends();
    if (this.id) {
      this.fetchDetail();
    } else {
      // 创建时领券/秒杀/拼团/积分兑换专区默认各展示一个
      this.addItem(MODULE_TYPE.COUPON);
      this.addItem(MODULE_TYPE.SEC_KILL);
      this.addItem(MODULE_TYPE.GROUP_BUY);
      this.addItem(MODULE_TYPE.POINTS);
    }
  },
  methods: {
    getDefaultForm: function getDefaultForm() {
      return {
        id: null,
        title: '',
        subTitle: '',
        remark: '',
        startTime: null,
        endTime: null,
        dayStartTime: '10:30',
        dayEndTime: '23:00',
        weeks: '',
        rule: '',
        shareTitle: '',
        shareImgUrl: '',
        bannerUrl: '',
        bannerUrl2: '',
        bgUrl: '',
        preheatImgUrl: '',
        preheatStartTime: null,
        preheatEndTime: null,
        enabled: 1,
        sort: 0
      };
    },
    // 默认专区顺序：领券专区、秒杀专区、拼团专区、抽奖专区、积分兑换、积分翻倍
    getDefaultZoneOrder: function getDefaultZoneOrder() {
      return [MODULE_TYPE.COUPON, MODULE_TYPE.SEC_KILL, MODULE_TYPE.GROUP_BUY, MODULE_TYPE.LOTTERY, MODULE_TYPE.POINTS, MODULE_TYPE.POINT_DOUBLE];
    },
    getDefaultModules: function getDefaultModules() {
      return this.getDefaultZoneOrder().map(function (type, index) {
        return {
          moduleType: type,
          title: '',
          subTitle: '',
          showStatus: 1,
          sort: index + 1,
          refId: null,
          imgUrl: '',
          pageId: null,
          items: []
        };
      });
    },
    getModule: function getModule(type) {
      return this.modules.find(function (m) {
        return m.moduleType === type;
      });
    },
    getModuleDef: function getModuleDef(type) {
      return this.moduleDefs.find(function (d) {
        return d.type === type;
      }) || {};
    },
    // 专区开关切换：关闭的专区沉到列表底部并隐藏左侧页签，重新开启时插回开启专区末尾并恢复页签
    handleZoneStatusChange: function handleZoneStatusChange(type) {
      var _this4 = this;
      var mod = this.getModule(type);
      var idx = this.zoneOrder.indexOf(type);
      if (idx === -1) return;
      this.zoneOrder.splice(idx, 1);
      if (Number(mod.showStatus) === 1) {
        var firstDisabledIdx = this.zoneOrder.findIndex(function (t) {
          return Number(_this4.getModule(t).showStatus) !== 1;
        });
        var insertAt = firstDisabledIdx === -1 ? this.zoneOrder.length : firstDisabledIdx;
        this.zoneOrder.splice(insertAt, 0, type);
      } else {
        this.zoneOrder.push(type);
        // 正停留在被关闭的专区页签时切回活动设置
        if (this.activeModule === 'module_' + type) {
          this.activeModule = 'setting';
        }
      }
    },
    // 获取装修页面列表（用于积分翻倍跳转页面选择）
    fetchPageList: function fetchPageList() {
      var _this5 = this;
      (0, _popupConfig.queryPageList)().then(function (response) {
        _this5.allPage = (response && response.data || []).map(function (p) {
          return {
            id: p.id,
            label: p.pageName || '',
            appid: p.appid
          };
        }).filter(function (p) {
          return p.id != null;
        });
        // 详情先于页面列表返回时补一次回显
        _this5.syncPdJumpType();
        _this5.syncLotteryJumpType();
      }).catch(function () {});
    },
    // 根据已选跳转页面归属应用回显跳转类型（未选择时默认社区）
    syncPdJumpType: function syncPdJumpType() {
      var pd = this.getModule(MODULE_TYPE.POINT_DOUBLE);
      if (!pd || pd.refId == null) return;
      var page = this.allPage.find(function (p) {
        return String(p.id) === String(pd.refId);
      });
      if (!page) return;
      this.pdJumpType = page.appid === 'GAGAX' || page.appid === 'DELI' ? 'dining' : 'community';
    },
    // 根据抽奖专区已选跳转页面归属应用回显跳转类型（未选择时默认社区）
    syncLotteryJumpType: function syncLotteryJumpType() {
      var mod = this.getModule(MODULE_TYPE.LOTTERY);
      if (!mod || mod.pageId == null) return;
      var page = this.allPage.find(function (p) {
        return String(p.id) === String(mod.pageId);
      });
      if (!page) return;
      this.lotteryJumpType = page.appid === 'GAGAX' || page.appid === 'DELI' ? 'dining' : 'community';
    },
    // 跳转页面选项过滤：社区=GAGAS，点餐=GAGAX/DELI
    filterPagesByJumpType: function filterPagesByJumpType(jumpType) {
      if (jumpType === 'dining') {
        return this.allPage.filter(function (p) {
          return p.appid === 'GAGAX' || p.appid === 'DELI';
        });
      }
      return this.allPage.filter(function (p) {
        return p.appid === 'GAGAS';
      });
    },
    // 切换跳转类型后清空已选页面，避免类型与页面不匹配
    handlePdJumpTypeChange: function handlePdJumpTypeChange() {
      this.getModule(MODULE_TYPE.POINT_DOUBLE).refId = null;
    },
    handleLotteryJumpTypeChange: function handleLotteryJumpTypeChange() {
      this.getModule(MODULE_TYPE.LOTTERY).pageId = null;
    },
    // 领券专区：查询扫码领券活动列表(xy_bonus_send)，创建时仅提供有效(激活)且会员日类型(event=7)的活动
    fetchBonusSends: function fetchBonusSends() {
      var _this6 = this;
      (0, _bonusSend.getBonusSendList)({
        page: 1,
        limit: 500,
        event: 7
      }).then(function (response) {
        var records = response && response.records || [];
        _this6.bonusSendOptions = records.filter(function (r) {
          return r.id != null && Number(r.enabled) === 1;
        }).map(function (r) {
          return {
            id: r.id,
            label: r.title || ''
          };
        });
        // 详情先于发券列表返回时补一次回显
        _this6.syncBonusSendOptions();
      }).catch(function () {});
    },
    // 编辑回显：已绑定的发券活动可能已不在有效列表中(未激活)，按ID补查后追加到下拉选项
    syncBonusSendOptions: function syncBonusSendOptions() {
      var _this7 = this;
      var items = this.getModule(MODULE_TYPE.COUPON).items || [];
      var missingIds = [];
      items.forEach(function (it) {
        if (it.refId == null) return;
        var bound = _this7.bonusSendOptions.some(function (o) {
          return String(o.id) === String(it.refId);
        });
        if (!bound && missingIds.indexOf(it.refId) === -1) {
          missingIds.push(it.refId);
        }
      });
      missingIds.forEach(function (id) {
        (0, _bonusSend.getBonusSendDetail)(id).then(function (response) {
          var c = response && response.data || response;
          if (!c) return;
          if (c.id == null || _this7.bonusSendOptions.some(function (o) {
            return String(o.id) === String(c.id);
          })) return;
          _this7.bonusSendOptions.push({
            id: c.id,
            label: c.title || ''
          });
        }).catch(function () {});
      });
    },
    // 通用：从分页响应提取记录数组（兼容 records / data.records / extra.records / data数组 / 顶层数组）
    extractRecords: function extractRecords(response) {
      var candidates = [response && response.records, response && response.data && response.data.records, response && response.extra && response.extra.records, response && response.data, response];
      return candidates.find(function (c) {
        return Array.isArray(c);
      }) || [];
    },
    // 秒杀专区：查询秒杀活动列表(xy_sec_kill)，创建时仅提供启用的活动
    fetchSecKills: function fetchSecKills() {
      var _this8 = this;
      (0, _secKill.getSecKillList)({
        page: 1,
        limit: 500
      }).then(function (response) {
        var records = response && response.records || [];
        _this8.secKillOptions = records.filter(function (r) {
          return r.id != null && Number(r.enabled) === 1;
        }).map(function (r) {
          return {
            id: r.id,
            label: r.title || ''
          };
        });
        // 详情先于秒杀列表返回时补一次回显
        _this8.syncSecKillOptions();
      }).catch(function () {});
    },
    // 编辑回显：已绑定的秒杀活动可能已不在启用列表中，按ID补查后追加到下拉选项
    syncSecKillOptions: function syncSecKillOptions() {
      var _this9 = this;
      var items = this.getModule(MODULE_TYPE.SEC_KILL).items || [];
      var missingIds = [];
      items.forEach(function (it) {
        if (it.refId == null) return;
        var bound = _this9.secKillOptions.some(function (o) {
          return String(o.id) === String(it.refId);
        });
        if (!bound && missingIds.indexOf(it.refId) === -1) {
          missingIds.push(it.refId);
        }
      });
      missingIds.forEach(function (id) {
        (0, _secKill.getSecKillDetail)(id).then(function (response) {
          var c = response && response.data || response;
          if (!c) return;
          if (c.id == null || _this9.secKillOptions.some(function (o) {
            return String(o.id) === String(c.id);
          })) return;
          _this9.secKillOptions.push({
            id: c.id,
            label: c.title || ''
          });
        }).catch(function () {});
      });
    },
    // 拼团专区：查询拼团活动列表(xy_group_buy)，创建时仅提供启用的活动
    fetchGroupBuys: function fetchGroupBuys() {
      var _this0 = this;
      (0, _groupBuy.getGroupBuyList)({
        page: 1,
        limit: 500
      }).then(function (response) {
        var records = response && response.records || [];
        _this0.groupBuyOptions = records.filter(function (r) {
          return r.id != null && Number(r.enabled) === 1;
        }).map(function (r) {
          return {
            id: r.id,
            label: r.title || ''
          };
        });
        // 详情先于拼团列表返回时补一次回显
        _this0.syncGroupBuyOptions();
      }).catch(function () {});
    },
    // 编辑回显：已绑定的拼团活动可能已不在启用列表中，按ID补查后追加到下拉选项
    syncGroupBuyOptions: function syncGroupBuyOptions() {
      var _this1 = this;
      var items = this.getModule(MODULE_TYPE.GROUP_BUY).items || [];
      var missingIds = [];
      items.forEach(function (it) {
        if (it.refId == null) return;
        var bound = _this1.groupBuyOptions.some(function (o) {
          return String(o.id) === String(it.refId);
        });
        if (!bound && missingIds.indexOf(it.refId) === -1) {
          missingIds.push(it.refId);
        }
      });
      missingIds.forEach(function (id) {
        (0, _groupBuy.getGroupBuyDetail)(id).then(function (response) {
          var c = response && response.data || response;
          if (!c) return;
          if (c.id == null || _this1.groupBuyOptions.some(function (o) {
            return String(o.id) === String(c.id);
          })) return;
          _this1.groupBuyOptions.push({
            id: c.id,
            label: c.title || ''
          });
        }).catch(function () {});
      });
    },
    // 秒杀/拼团/积分兑换专区卡片选项数据源
    getZoneItemOptions: function getZoneItemOptions(type) {
      switch (type) {
        case MODULE_TYPE.SEC_KILL:
          return this.secKillOptions;
        case MODULE_TYPE.GROUP_BUY:
          return this.groupBuyOptions;
        case MODULE_TYPE.POINTS:
          return this.pointsOptions;
        default:
          return [];
      }
    },
    // 专区简称（去掉"专区"后缀，用于卡片命名：秒杀/拼团/积分兑换）
    zoneShortName: function zoneShortName(type) {
      return (this.getModuleDef(type).label || '').replace('专区', '');
    },
    // 提示字段命名：积分兑换简称"积分"
    zoneTipsName: function zoneTipsName(type) {
      return type === MODULE_TYPE.POINTS ? '积分' : this.zoneShortName(type);
    },
    // 抽奖专区：查询抽奖活动列表(xy_award)，创建时仅提供有效(启用)的活动
    fetchLotteries: function fetchLotteries() {
      var _this10 = this;
      (0, _lottery.getLotteryList)({
        page: 1,
        limit: 500
      }).then(function (response) {
        // 抽奖列表分页数据在 extra 中（与秒杀/拼团的 records 结构不同）
        var records = response && response.extra && response.extra.records || response && response.records || [];
        _this10.lotteryOptions = records.filter(function (r) {
          return r.id != null && Number(r.enabled) === 1;
        }).map(function (r) {
          return {
            id: r.id,
            label: r.title || ''
          };
        });
        // 详情先于抽奖列表返回时补一次回显
        _this10.syncLotteryOptions();
      }).catch(function () {});
    },
    // 编辑回显：已绑定的抽奖活动可能已不在有效列表中，按ID补查后追加到下拉选项
    syncLotteryOptions: function syncLotteryOptions() {
      var _this11 = this;
      var mod = this.getModule(MODULE_TYPE.LOTTERY);
      if (!mod || mod.refId == null) return;
      if (this.lotteryOptions.some(function (o) {
        return String(o.id) === String(mod.refId);
      })) return;
      (0, _lottery.getLotteryDetail)(mod.refId).then(function (response) {
        var c = response && response.data || response;
        if (!c || c.id == null) return;
        if (_this11.lotteryOptions.some(function (o) {
          return String(o.id) === String(c.id);
        })) return;
        _this11.lotteryOptions.push({
          id: c.id,
          label: c.title || ''
        });
      }).catch(function () {});
    },
    // 积分兑换专区：查询兑换规则列表（xy_points_rule，含已下架并在选项中标注；编辑回显天然包含已绑定规则）
    fetchPointsRules: function fetchPointsRules() {
      var _this12 = this;
      (0, _memberDay.getPointsRuleList)({
        page: 1,
        limit: 500
      }).then(function (res) {
        _this12.pointsOptions = _this12.extractRecords(res).map(function (r) {
          var points = Number(r.points) || 0;
          var cash = Number(r.cashAmount) || 0;
          var priceText = points + '积分' + (cash > 0 ? '+' + cash + '元' : '');
          var name = r.activityName || r.relationName || '';
          var shelfMark = r.shelfStatus === 'up' ? '' : '[已下架]';
          return {
            id: r.id,
            label: name + '（' + priceText + '）' + shelfMark
          };
        }).filter(function (o) {
          return o.id != null;
        });
        if (_this12.pointsOptions.length === 0) {
          console.warn('兑换活动下拉数据为空，原始响应：', res);
        }
      }).catch(function (e) {
        console.warn('兑换活动下拉查询失败：', e);
      });
    },
    fetchDetail: function fetchDetail() {
      var _this13 = this;
      this.loading = true;
      (0, _memberDay.getMemberDayActivityDetail)(this.id).then(function (response) {
        var data = response && response.data || response;
        if (!data) {
          _this13.$message.error('活动不存在');
          return;
        }
        // 主表字段回填
        Object.keys(_this13.form).forEach(function (key) {
          if (data[key] !== undefined && data[key] !== null) {
            _this13.form[key] = data[key];
          }
        });
        _this13.form.id = data.id;
        _this13.timeRange = data.startTime && data.endTime ? [data.startTime, data.endTime] : null;
        _this13.preheatRange = data.preheatStartTime && data.preheatEndTime ? [data.preheatStartTime, data.preheatEndTime] : null;
        _this13.weeksArr = data.weeks ? String(data.weeks).split(',').map(function (w) {
          return parseInt(w);
        }).filter(function (w) {
          return w >= 1 && w <= 7;
        }) : [];
        // 模块回填
        var modules = data.modules || [];
        _this13.moduleDefs.forEach(function (def) {
          var local = _this13.getModule(def.type);
          var remote = modules.find(function (m) {
            return m.moduleType === def.type;
          });
          if (remote) {
            local.title = remote.title || '';
            local.subTitle = remote.subTitle || '';
            local.showStatus = remote.showStatus != null ? remote.showStatus : 1;
            local.sort = remote.sort != null ? remote.sort : def.type;
            local.refId = remote.refId || null;
            local.imgUrl = remote.imgUrl || '';
            local.pageId = remote.pageId || null;
            local.items = (remote.items || []).map(function (it, idx) {
              return {
                refId: it.refId,
                tips: it.tips || '',
                imgUrl: it.imgUrl || '',
                description: it.description || '',
                endTime: it.endTime || null,
                // 秒杀/拼团/积分兑换专区排序默认按行递增，其余专区默认0
                sort: it.sort != null ? it.sort : def.type === MODULE_TYPE.SEC_KILL || def.type === MODULE_TYPE.GROUP_BUY || def.type === MODULE_TYPE.POINTS ? idx + 1 : 0
              };
            });
          }
        });
        // 专区顺序回填：开启的在前、关闭的沉底（各按已保存 sort 排序），历史数据缺失的专区按默认顺序补到末尾
        var knownTypes = _this13.moduleDefs.map(function (d) {
          return d.type;
        });
        var remoteSorted = modules.filter(function (m) {
          return knownTypes.indexOf(m.moduleType) !== -1;
        }).sort(function (a, b) {
          return (a.sort || 0) - (b.sort || 0) || (a.id || 0) - (b.id || 0);
        });
        _this13.zoneOrder = remoteSorted.filter(function (m) {
          return Number(m.showStatus) === 1;
        }).concat(remoteSorted.filter(function (m) {
          return Number(m.showStatus) !== 1;
        })).map(function (m) {
          return m.moduleType;
        });
        _this13.getDefaultZoneOrder().forEach(function (type) {
          if (_this13.zoneOrder.indexOf(type) === -1) {
            _this13.zoneOrder.push(type);
          }
        });
        // 按已选页面归属回显积分翻倍/抽奖专区跳转类型
        _this13.syncPdJumpType();
        _this13.syncLotteryJumpType();
        // 已绑定的发券活动若不在有效列表中，按ID补查后追加到下拉
        _this13.syncBonusSendOptions();
        // 已绑定的秒杀活动若不在启用列表中，按ID补查后追加到下拉
        _this13.syncSecKillOptions();
        // 已绑定的拼团活动若不在启用列表中，按ID补查后追加到下拉
        _this13.syncGroupBuyOptions();
        // 已绑定的抽奖活动若不在有效列表中，按ID补查后追加到下拉
        _this13.syncLotteryOptions();
        _this13.loading = false;
      }).catch(function (error) {
        console.error('获取会员日活动详情失败:', error);
        _this13.$message.error('获取详情失败');
        _this13.loading = false;
      });
    },
    handleCheckAllWeek: function handleCheckAllWeek(val) {
      this.weeksArr = val ? [1, 2, 3, 4, 5, 6, 7] : [];
    },
    addItem: function addItem(type) {
      var mod = this.getModule(type);
      // 秒杀/拼团/积分兑换专区排序默认递增（当前最大排序+1），其余专区按行序
      var sort = type === MODULE_TYPE.SEC_KILL || type === MODULE_TYPE.GROUP_BUY || type === MODULE_TYPE.POINTS ? mod.items.reduce(function (max, it) {
        return Math.max(max, Number(it.sort) || 0);
      }, 0) + 1 : mod.items.length;
      mod.items.push({
        refId: null,
        tips: '',
        imgUrl: '',
        description: '',
        endTime: null,
        sort: sort
      });
    },
    removeItem: function removeItem(type, index) {
      this.getModule(type).items.splice(index, 1);
    },
    handleSave: function handleSave() {
      var _this14 = this;
      this.$refs.mainForm.validate(function (valid) {
        if (!valid) {
          _this14.activeModule = 'setting';
          _this14.$message.warning('请完善活动设置的必填项');
          return;
        }
        // 校验明细行（抽奖专区无明细下拉必填校验，积分翻倍专区无明细）
        var _iterator = _createForOfIteratorHelper(_this14.moduleDefs),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var def = _step.value;
            var mod = _this14.getModule(def.type);
            if (mod.showStatus === 1) {
              if (def.type === MODULE_TYPE.LOTTERY) {
                if (!mod.refId) {
                  // 抽奖显示时未选活动，允许为空则隐藏，不强制；这里不阻断
                }
              } else if (def.type !== MODULE_TYPE.POINT_DOUBLE) {
                var empty = mod.items.find(function (it) {
                  return it.refId == null;
                });
                if (empty) {
                  _this14.activeModule = 'module_' + def.type;
                  _this14.$message.warning(def.label + '存在未选择' + def.itemLabel + '的明细行，请补全或删除');
                  return;
                }
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var payload = _objectSpread(_objectSpread({}, _this14.form), {}, {
          startTime: _this14.timeRange ? _this14.timeRange[0] : null,
          endTime: _this14.timeRange ? _this14.timeRange[1] : null,
          preheatStartTime: _this14.preheatRange ? _this14.preheatRange[0] : null,
          preheatEndTime: _this14.preheatRange ? _this14.preheatRange[1] : null,
          weeks: (0, _toConsumableArray2.default)(_this14.weeksArr).sort(function (a, b) {
            return a - b;
          }).join(','),
          // 模块 sort 按活动设置中的专区顺序写入(1开始)
          modules: _this14.modules.map(function (m) {
            return {
              moduleType: m.moduleType,
              title: m.title,
              subTitle: m.subTitle,
              showStatus: m.showStatus,
              sort: _this14.zoneOrder.indexOf(m.moduleType) + 1,
              refId: m.refId,
              imgUrl: m.imgUrl || '',
              pageId: m.pageId,
              items: (m.items || []).map(function (it, idx) {
                return {
                  refId: it.refId,
                  tips: it.tips,
                  imgUrl: it.imgUrl || '',
                  description: it.description || '',
                  endTime: it.endTime || null,
                  sort: it.sort != null ? it.sort : idx
                };
              })
            };
          })
        });
        _this14.saving = true;
        (0, _memberDay.saveMemberDayActivity)(payload).then(function (response) {
          if (response.code === 200) {
            _this14.$message.success('保存成功');
            _this14.$emit('success');
          } else {
            _this14.$message.error(response.message || '保存失败');
          }
          _this14.saving = false;
        }).catch(function (error) {
          _this14.$message.error('保存失败：' + (error.message || error));
          _this14.saving = false;
        });
      });
    },
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    }
  }
};